import { BadgeType } from '@tribeplatform/gql-client/types'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { MemberBadgeLocation } from '@tribeplatform/react-components/MemberBadge'
import { getPropertyValue } from '@tribeplatform/react-ui-kit/utils'

export const locationOptionsFactory = ({ $t }: I18nShape) => [
  {
    text: $t({
      defaultMessage: 'Profile header',
      id: 'Admin.Badge.Location.ProfileHeader',
    }),
    value: MemberBadgeLocation.ProfileName,
  },
  {
    text: $t({
      defaultMessage: 'Post member bar',
      id: 'Admin.Badge.Location.MemberBar',
    }),
    value: MemberBadgeLocation.PostMemberBar,
  },
  {
    text: $t({
      defaultMessage: 'Members list',
      id: 'Admin.Badge.Location.MemberList',
    }),
    value: MemberBadgeLocation.MembersList,
  },
]
export const badgeStylesFactory = (document: Document) => [
  {
    bg: getPropertyValue(document, '--bm-color-surface-neutral'),
    text: getPropertyValue(document, '--bm-color-content-subdued'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-1-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-1'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-2-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-2'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-3-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-3'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-4-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-4'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-5-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-5'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-6-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-6'),
  },
  {
    bg: getPropertyValue(document, '--bm-color-decorative-surface-7-subdued'),
    text: getPropertyValue(document, '--bm-color-decorative-content-7'),
  },
]

export const smartBadgeNameMappingFactory = ({ $t }: I18nShape) => ({
  [BadgeType.NewMember]: $t({
    defaultMessage: 'New {MEMBER}',
    id: 'Generics.NewMember',
  }),
  [BadgeType.Role]: $t({ defaultMessage: 'Role', id: 'Generics.Role' }),
})
